export default function SocialVimeoOutline() {
  return (
    <div
      className="ion-icon-social-vimeo-outline"
      dangerouslySetInnerHTML={{
        __html: `<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 16.2.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="512px" height="512px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
<path d="M476.9,114c-5-23.4-17.5-38.8-40.6-46.3c-7.4-2.4-16.7-3.7-26.9-3.7c-21.7,0-47.4,6-67.2,20.5
	c-29.9,21.8-47.6,59.7-53.8,83.8c12.2-5.3,20.8-7.1,31.9-7.1c2.2,0,4.6,0.1,7.1,0.2c15,0.8,24.5,12,24.9,25.3
	c0.3,9.8-0.2,18.7-3.6,27.7c-10.8,28.7-27.7,56.5-47.6,80.8c-2.9,3.6-6.4,6.9-10,9.9c-4.1,3.4-8,5-11.6,5c-5.2,0-9.9-3.5-13.8-10.2
	c-5.4-9.3-9-18.9-12.2-29.1c-12.4-39.7-16.8-80.9-23.8-121.6c-3.3-19.5-7-39.8-18-56.9c-10-15.4-24-22.6-41.5-22.6
	c-2.8,0-5.6,0.2-8.6,0.5c-14.7,1.8-36.9,17.5-47.8,26.4c0,0-56,46.9-81.8,71.4l21.2,27c0,0,17.9-12.5,27.5-18.3
	c2.9-1.8,6.1-2.8,9.2-2.8c2.9,0,5.7,0.9,8,3c4.5,3.9,9.6,9,12.3,14.1c5.7,10.7,11.2,21.9,14.7,33.4c13.2,44.3,25.5,88.7,37.8,133.3
	c6.3,22.8,13.9,44.2,28,63.6c13.2,18.2,26.9,26.8,44.3,26.8c8,0,16.8-1.8,26.6-5.4c25.4-9.1,46.6-26.2,66-43.9
	c33.1-30.2,59.1-65.4,85.5-101.2c20.4-27.7,37.3-55.7,51.4-87C478.5,179.8,484,147.3,476.9,114z M450,203.9
	c-13.3,29.4-29.1,56.2-49.7,84.1l-0.3,0.4c-26.4,35.7-51.3,69.5-83.1,98.5c-17.8,16.3-37.5,32.4-60.6,40.7c-8.3,3-15.2,4.4-21.2,4.4
	c-8.2,0-18.4-2.4-31.4-20.2c-13.4-18.4-20.2-39-25.5-58.4c-12.4-45.1-24.6-89.2-37.9-133.6c-3.9-13.2-10.2-25.8-15.9-36.4
	c-3.2-5.9-8.4-12-15.9-18.6c-5.2-4.5-11.6-6.9-18.6-6.9c-5.9,0-12,1.8-17.5,5.1c-4.5,2.7-10.5,6.7-15.9,10.3l-2.8-3.6
	c26.9-24.4,68.3-59.1,70.3-60.8C138.8,96.8,155.8,87,163.5,86c2.3-0.3,4.5-0.4,6.6-0.4c12.4,0,21.3,4.9,28.1,15.3
	c9.5,14.7,12.8,33.9,15.7,50.9c1.6,9.7,3.2,19.6,4.7,29.1c4.8,31.1,9.8,63.3,19.6,94.6c3,9.7,7,21.2,13.6,32.5
	c8.8,15,19.9,18.1,27.6,18.1c7.4,0,14.7-2.9,21.7-8.6c4.6-3.7,8.7-7.8,12.3-12.2c21.9-26.8,39.3-56.3,50.2-85.3
	c4.5-12,4.9-23.3,4.6-33.8c-0.6-22.4-17.4-39.6-40-40.9c-2.9-0.2-5.5-0.2-8-0.2c-2.2,0-4.3,0.1-6.3,0.2
	c8.8-18.1,21.7-36.3,37.7-47.9c15-10.9,36.6-17.5,57.8-17.5c8.3,0,16.1,1,21.9,2.9c17,5.5,26,15.8,29.9,34.4
	C467.2,145.1,463.4,174.2,450,203.9z"/>
</svg>
`,
      }}
    />
  )
}
